/**
 * Configuration for Report Filter Buttons
 */

const config = [
  {
    id: "filters",
    action: "filters",
    label: "Filters",
    icon: "filter",
    attributes: {
      "data-event-category": "View Filters",
      "data-event-action": "Open",
    },
  },
  {
    id: "group-by",
    action: "group-by",
    label: "Group By",
    icon: "list",
    attributes: {
      "data-event-category": "View Group By",
      "data-event-action": "Open",
    },
  },
];

export { config as default };
